import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import DataTables from 'material-ui-datatables';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import moment from 'moment';
import FileSaver from 'file-saver';
import json2csv from 'json2csv';

import { sortDates, sortStrings, contains, getOrderDirection } from '../../utils/helper';

import { fetchJobs, setJob } from '../../actions/jobs';
import { removeJobRoutine } from '../../routines';
import { showDialog, hideDialog, isDialogOpen } from '../../actions/dialogs';
import Dashboard from '../Dashboard';
import CreateJobDialog from '../CreateJobDialog';
import { hasPermission } from '../../utils/authenticated';
import JobDialog from '../JobDialog';
import Loading from '../Common/Loading';

import styles from './styles';

const generateCsv = (jobs) => {
  const fields = ['id', 'reference', 'customer.name', 'primaryContact.name', 'start', 'end', 'origin.line1', 'origin.line2', 'origin.city', 'origin.state', 'origin.country', 'origin.postalCode', 'destination.line1', 'destination.line2', 'destination.city', 'destination.state', 'destination.country', 'destination.postalCode', 'profile.name', 'tasks.count', 'created.at', 'updated.at'];
  const csv = json2csv({ data: jobs, fields });
  const blob = new Blob([csv], { type: 'text/csv' });
  FileSaver.saveAs(blob, 'jobs.csv');
};

const getTableColumns = (editable, onEdit, onRemove, onExport) => {
  return _.flatten([
    {
      key: 'reference',
      label: 'Reference',
      render: (reference, job) => reference,
      sortable: true,
      style: styles.referenceCol,
    }, {
      key: 'customer',
      label: 'Customer',
      render: (customer, job) => customer ? customer.name : '',
      sortable: true,
      style: styles.customerCol,
    }, {
      key: 'description',
      label: 'Description',
      render: (description, job) => description,
      style: styles.descriptionCol,
    }, {
      key: 'primaryContact',
      label: 'Primary Contact',
      render: (primaryContact, job) => primaryContact ? primaryContact.name : '',
      sortable: true,
      style: styles.primaryContactCol,
    }, {
      key: 'start',
      label: 'Start',
      render: (start, job) => moment(start).format('ll'),
      sortable: true,
      style: styles.startCol,
      // }, {
      //   key: 'end',
      //   label: 'End',
      //   render: (start, job) => moment(start).format('ll'),
      //   sortable: true,
      //   style: styles.endCol,
    }, {
      key: 'tasks',
      label: 'Task Count',
      render: (tasks, job) => tasks ? tasks.count : 0,
      sortable: true,
      style: styles.tasksCol,
    }, {
      key: 'created',
      label: 'Created',
      render: (created) => created ? moment(created.at).format('lll') : '',
      sortable: true,
      style: styles.createdCol,
    }, {
      key: 'action',
      label: (
        <IconMenu
          iconButtonElement={<IconButton>
            <FontIcon
              color={'grey'}
              className="material-icons">file_download</FontIcon></IconButton>}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onChange={onExport}
        >
          <MenuItem value="export-all" primaryText="Export All"/>
          <MenuItem value="export-current-page" primaryText="Export Current Page"/>
          <MenuItem value="export-selected" primaryText="Export Selected"/>
        </IconMenu>),
      render: (a, job) => {
        return (<span>{editable ? <IconButton
          tooltip="Edit"
          tooltipPosition="bottom-center"
          onClick={(evt) => onEdit(evt, job)}
        >
          <FontIcon
            className="material-icons"
            style={styles.icon}
          >edit</FontIcon>
        </IconButton> : null}
          {editable ? <IconButton
            tooltip="Remove"
            tooltipPosition="bottom-center"
            onClick={(evt) => onRemove(evt, job)}
          >
            <FontIcon
              className="material-icons"
              style={styles.icon}
            >delete</FontIcon>
          </IconButton> : null}
          </span>);
      },
      alignRight: true,
      style: styles.actionCol,
    },
  ]);
};

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b);

    if (result === 0) {
      result = sortDates(a.start, b.start);

      if (result === 0) {
        result = sortDates(a.end, b.end);

        if (result === 0) {
          result = sortStrings(a.id, b.id);
        }
      }
    }

    return result * getOrderDirection(order);
  };
};

const getJobFilter = (filter) => {
  return (job) => {
    if (filter) {
      if (job.reference && contains(job.reference, filter)) {
        return true;
      }
      if (job.customer && contains(job.customer.name, filter)) {
        return true;
      }
      if (job.primaryContact && contains(job.primaryContact.name, filter)) {
        return true;
      }
      if (contains(job.description, filter)) {
        return true;
      }
      // if (job.customer && contains(job.customer.name, filter)) {
      //   return true;
      // }

      return false;
    }

    return true;
  };
};

class Jobs extends Component {
  static propTypes = {
    fetchJobs: PropTypes.func.isRequired,
    setJob: PropTypes.func.isRequired,
    removeJob: PropTypes.func.isRequired,
    jobs: PropTypes.array.isRequired,
    loading: PropTypes.bool,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    dialogs: PropTypes.object.isRequired,
  };

  state = {
    selectedRows: [],
    page: 1,
    limit: 10,
    sortBy: getSorter((a, b) => sortDates(a.start, b.start), 'desc'),
    order: 'asc',
    data: [],
  };

  componentWillMount() {
    this.props.fetchJobs();

    this.setState({
      editable: hasPermission(['Administrator', 'JobCreator']),
      data: this.props.jobs.sort(this.state.sortBy),
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.jobs.sort(this.state.sortBy),
    });
  }

  handleCreateJobRequest = () => {
    this.props.setJob({});
    this.props.showDialog('createJob');
  };

  handleFilterValueChange = (filter) => {
    const { jobs } = this.props;
    const { page, limit, sortBy } = this.state;

    const data = jobs.filter(getJobFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
    this.setState({
      page: Math.min(page, Math.floor(data.length / limit) + 1),
      data,
    });
  };

  handleSortOrderChange = (key, order) => {
    let sortBy = getSorter();
    switch (key) {
      case 'reference':
        sortBy = getSorter((a, b) => sortStrings(a.reference, b.reference), order);
        break;
      case 'customer':
        sortBy = getSorter((a, b) => sortStrings(a.customer ? a.customer.name : '', b.customer ? b.customer.name : ''), order);
        break;
      case 'primaryContact':
        sortBy = getSorter((a, b) => sortStrings(a.primaryContact ? a.primaryContact.name : '', b.primaryContact ? b.primaryContact.name : ''), order);
        break;
      case 'start':
        sortBy = getSorter((a, b) => sortDates(a.start, b.start), order);
        break;
      case 'end':
        sortBy = getSorter((a, b) => sortDates(a.end, b.end), order);
        break;
      case 'tasks':
        sortBy = getSorter((a, b) => {
          const aCount = (a && a.tasks && a.tasks.count) ? a.tasks.count : 0;
          const bCount = (b && b.tasks && b.tasks.count) ? b.tasks.count : 0;

          return aCount - bCount;
        }, order);
        break;
      case 'created':
        console.log('order', order);
        sortBy = getSorter((a, b) => sortDates(a.created ? a.created.at : new Date(), b.created ? b.created.at : new Date()), order);
        break;
      default:
        break;
    }

    this.setState({
      data: this.state.data.sort(sortBy),
      sortBy,
    });
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  handleRemoveJob = (job) => {
    this.handleRemoveJobs([job]);
  };

  handleMultiRemove = () => {
    if (this.state.selectedRows.length < 1) {
      return null;
    }

    const { data, page, limit } = this.state;
    const currentData = data.slice((page - 1) * limit, page * limit);
    const jobs = currentData.filter((job, index) => {
      return ((this.state.selectedRows.map((val) => val)).includes(index));
    });

    this.handleRemoveJobs(jobs);
  };

  handleRemoveJobs = (jobs) => {
    const context = {
      type: 'warning',
      title: 'Remove Jobs?',
      message: `Are you sure you wish to remove the ${jobs.length > 1 ? jobs.length : ''} 
      selected ${jobs.length > 1 ? 'jobs' : 'job'}?`,
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            jobs.map(this.props.removeJob);
            this.setState({
              selectedRows: [],
            });
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  handleRowSelection = (evt) => {
    let selectedRows = [];
    switch (evt) {
      case 'all':
        selectedRows = _.range(0, this.state.limit);
        break;
      case 'none':
        selectedRows = [];
        break;
      default:
        selectedRows = evt;
        break;
    }

    this.setState({
      selectedRows,
    });
  };

  handleGenerateLabels = (job) => {
    // TODO check if tasks exist
    this.props.setJob(job);
    this.props.showDialog('generateLabels');
  };

  handleEdit = (evt, job) => {
    evt.stopPropagation();
    this.props.setJob(job);
    this.props.showDialog('job');
  };

  handleRemove = (evt, job) => {
    evt.stopPropagation();
    this.handleRemoveJob(job);
  };

  handleExport = (evt, val) => {
    console.log('onExport', val);
    switch (val) {
      case 'export-current-page':
        generateCsv(this.state.data);
        break;
      case 'export-selected':
        generateCsv(_.at(this.state.data, this.state.selectedRows));
        break;
      case 'export-all':
      default:
        generateCsv(this.props.jobs);
        break;
    }
  };

  renderNoData() {
    return (<div style={styles.noDataRow}>
      <FontIcon className="material-icons" style={styles.noData}>transform</FontIcon>
      <div>No jobs are available</div>
    </div>);
  }

  renderTable() {
    const { loading } = this.props;
    const { editable, page, limit, data } = this.state;

    if (loading) {
      return (<Loading/>);
    } else if (data.length > 0) {
      return (<DataTables
        height={'auto'}
        selectable
        multiSelectable
        showRowHover
        columns={getTableColumns(editable, this.handleEdit, this.handleRemove, this.handleExport)}
        data={data.slice((page - 1) * limit, page * limit)}
        showCheckboxes
        enableSelectAll
        selectedRows={this.state.selectedRows}
        onFilterValueChange={this.handleFilterValueChange}
        onSortOrderChange={this.handleSortOrderChange}
        onPreviousPageClick={this.handlePreviousPageClick}
        onNextPageClick={this.handleNextPageClick}
        onRowSizeChange={this.handleRowSizeChange}
        onRowSelection={this.handleRowSelection}
        page={page}
        rowSize={limit}
        rowSizeList={[10, 15, 25, 50, 100]}
        count={data.length}
        filterHintText="Filter"
        headerToolbarMode="filter"
        showHeaderToolbar
      />);
    }

    return this.renderNoData();
  }

  render() {
    const { editable } = this.state;

    return (
      <Dashboard title="Jobs">
        <div style={styles.wrapper}>
          {this.renderTable()}
        </div>

        {editable ? <FloatingActionButton
          style={styles.addItem}
          onClick={this.handleCreateJobRequest}
          secondary
        >
          <ContentAdd/>
        </FloatingActionButton> : null}

        {editable ? <FloatingActionButton
          style={styles.removeItem}
          onClick={this.handleMultiRemove}
          secondary
        >
          <FontIcon className="material-icons" style={styles.icon}>delete</FontIcon>
        </FloatingActionButton> : null}

        {isDialogOpen(this.props.dialogs, 'createJob') ?
          <CreateJobDialog onRequestClose={() => this.props.hideDialog('createJob')}/> : null}

        {isDialogOpen(this.props.dialogs, 'job') ? <JobDialog/> : null}
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJobs,
    setJob,

    removeJob: removeJobRoutine.trigger,

    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    jobs: state.get('jobs').get('jobs').toJS().filter((job) => !job.deleted),
    loading: state.get('jobs').get('loading'),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);



// WEBPACK FOOTER //
// ./src/components/Jobs/index.js